import React from "react";
import { IconProps } from "../../types/types";

const GraphIcon: React.FC<IconProps> = ({ size = "18", color = "white" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.74 8.99891C15.69 8.99891 16.5 8.24891 15.78 5.78891C15.2925 4.13141 13.8675 2.70641 12.21 2.21891C9.75 1.49891 9 2.30891 9 4.25891V6.41892C9 8.24892 9.75 8.99891 11.25 8.99891H13.74Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0017 11.027C14.3042 14.4995 10.9742 17.0195 7.18666 16.4045C4.34416 15.947 2.05666 13.6595 1.59166 10.817C0.984164 7.04452 3.48916 3.71452 6.94667 3.00952"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GraphIcon;
